document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartItems', () => {
    return {
      itemsRoot: null,
      locked: null,
      
      init() {
        this.itemsRoot = this.$root;
        window.addEventListener('cascade:modalcart:afteradditem', (e) => this.refreshCart(e.detail.response));
        window.addEventListener('cascade:modalcart:cartqtychange', (e) => this.refreshCart(e.detail.response));
      },

      refreshCart(response) {
        if (!response || !response.sections) return;
        Alpine.morph(
          this.itemsRoot,
          querySelectorInHTMLString('[data-cart-items]', response.sections['cart-items']).outerHTML
        );
      },

      // --- THE FIX: DIRECT UPDATE FUNCTION ---
      // We no longer search for inputs. We just send the command.
      updateQuantity(key, newQuantity) {
        if (this.locked) return;

        // Clean Inputs
        const id = key.trim();
        const quantity = parseInt(newQuantity, 10);

        if(!id) return;

        // Find row to lock it visually
        const lineItemEl = this.itemsRoot.querySelector(`li[data-cart-item-key="${id}"]`);
        if (lineItemEl) {
            this.locked = lineItemEl;
            lineItemEl.classList.add('opacity-50', 'pointer-events-none');
        }

        // Prepare Payload
        const config = fetchConfigDefaults('javascript');
        config.body = JSON.stringify({
          id: id,
          quantity: quantity,
          sections: 'cart-items,cart-footer,cart-item-count,cart-live-region',
          sections_url: window.location.pathname
        });

        // Execute Transfer
        fetch(theme.routes.cart_change_url, config)
        .then((res) => res.json())
        .then((data) => {
            if (data.status === 422) {
                // Error handling
                if(lineItemEl) lineItemEl.classList.remove('opacity-50', 'pointer-events-none');
                alert(data.message); 
            } else {
                // Success - Broadcast event to refresh DOM
                document.body.dispatchEvent(
                    new CustomEvent('cascade:modalcart:cartqtychange', {
                        bubbles: true,
                        detail: { response: data }
                    })
                );
            }
        })
        .finally(() => {
            this.locked = null;
        });
      },

      // Helper for the input field manual typing
      manualChange(key, inputEl) {
         this.updateQuantity(key, inputEl.value);
      }
    };
  });
});